import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '@/assets/login/login.jpg';
import _imports_1 from '@/assets/login/userName.png';
import _imports_2 from '@/assets/login/password.png';
const _hoisted_1 = {
  class: "login-container"
};
const _hoisted_2 = {
  class: "login_content"
};
const _hoisted_3 = {
  class: "login-form"
};
const _hoisted_4 = {
  class: "login_form"
};
import { reactive, onMounted } from 'vue';
import api from '@/server/request/api';
import { ElMessage } from 'element-plus';
import router from '@/router';
import { useRoute } from 'vue-router';
// 使用 reactive 创建表单数据对象
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const formData = reactive({
      username: '',
      password: ''
    });
    const route = useRoute();
    const handleLogin = () => {
      api.login(formData).then(resp => {
        if (resp.code == 200) {
          console.log(resp);
          localStorage.setItem('userInfo', JSON.stringify(resp.result));
          ElMessage.success('登录成功');
          router.push('/home');
        } else {
          ElMessage.error(resp.msg);
        }
      });
    };
    onMounted(() => {
      // 检查URL参数中是否包含用户名和密码
      const urlUsername = route.query.username;
      const urlPassword = route.query.password;
      if (urlUsername && urlPassword) {
        formData.username = urlUsername;
        formData.password = urlPassword;
        // 自动执行登录
        handleLogin();
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[8] || (_cache[8] = _createElementVNode("img", {
        class: "login-bg",
        src: _imports_0,
        alt: ""
      }, null, -1)), _createElementVNode("div", _hoisted_2, [_cache[7] || (_cache[7] = _createElementVNode("ul", {
        class: "login-title"
      }, [_createElementVNode("li", null, "专注于多源数据融合技术"), _createElementVNode("li", null, "赋能于军队、公安业务智能化"), _createElementVNode("li", null, "致力于服务国家安全")], -1)), _createElementVNode("div", _hoisted_3, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "login_title"
      }, "中科金联综合服务平台", -1)), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_form, {
        model: formData,
        ref: "loginForm",
        class: "form_item"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formData.username,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.username = $event),
            placeholder: "请输入手机号码",
            clearable: ""
          }, {
            prefix: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createElementVNode("img", {
              src: _imports_1,
              alt: "",
              style: {
                "width": "20px",
                "height": "20px"
              }
            }, null, -1)]))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          style: {
            "margin-top": "2vh"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            type: "password",
            modelValue: formData.password,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.password = $event),
            placeholder: "请输入密码",
            clearable: ""
          }, {
            prefix: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createElementVNode("img", {
              src: _imports_2,
              alt: "",
              style: {
                "width": "20px",
                "height": "20px"
              }
            }, null, -1)]))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          style: {
            "margin-top": "4vh"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            class: "login_btn",
            onClick: handleLogin
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("登录", -1)]))]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createElementVNode("div", {
            class: "login_footer"
          }, " 技术支持:中科金联(北京)科技有限公司 ", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])])])])]);
    };
  }
});